import { createContext, useContext } from "react";
import type { AccountStanding } from "@/lib/account-standing";

export const AccountStandingContext = createContext<AccountStanding | null>(null);

export function useAccountStanding(): AccountStanding | null {
  return useContext(AccountStandingContext);
}
